import { displayNotification } from './snackbarUtils'


export const displayErrorMessage = (data, customMessage) => {
  const message = data?.message || data?.messages?.[0]?.msg || customMessage || 'Error occurred';
  displayNotification.error(message);
};
